<template>
  <div class="impressao-dados-cenario-modulo">
    <div class="impressao-dados-coluna">
      <div class="impressao-dados-linha">
        <ImpressaoBloco :nome="'NCM:'" :dado="dadosCenario.ncm" />
        <ImpressaoBloco :nome="'Descrição:'" :dado="dadosCenario.ncmDescricao" />
      </div>
    </div>
  </div>
</template>

<script>
import ImpressaoBloco from "./ImpressaoBloco.vue";

export default {
  name: "ImpressaoNcm",
  components: { ImpressaoBloco },
  props: {
    dadosCenario: Array | Object
  }
};
</script>

<style lang="scss" scoped>
.impressao-dados-cenario-modulo {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  h2 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  h3 {
    font-size: 14px;
    font-weight: bold;
  }
  h4 {
    font-size: 12px;
    font-weight: bold;
  }
}
.impressao-dados-coluna {
  display: flex;
  flex-direction: column;
}
.impressao-dados-linha {
  display: flex;
  flex-direction: row;
}
</style>
